import { ValueProvider } from '@angular/core';
import {
  SyncValidator,
  ValidationContextBase,
  VALIDATOR_FACTORY,
} from 'app/core/validation';
import { Admin } from '../entities/entity-model';
import { WellKnownAppointmentTypes } from '../enums/wellknown-appointment-types';

export class OnlyOneSingleAppointmentTypeValidator extends SyncValidator {
  private static messageTemplate =
    "Appointment Type 'Single' is only valid with a single appointee";

  constructor(
    group: string,
    validatorContext?: Partial<ValidationContextBase>
  ) {
    super(
      'onlyOneSingleAppointmentType',
      group,
      (value, context) => {
        if (!value || !(value instanceof Admin)) {
          return true;
        }

        if (value.appointments.length > 1) {
          return value.appointments.every(
            (appointment) =>
              appointment.appointmentTypeId !== WellKnownAppointmentTypes.single
          );
        }
        return true;
      },
      {
        ...validatorContext,
        messageTemplate:
          validatorContext?.messageTemplate ||
          OnlyOneSingleAppointmentTypeValidator.messageTemplate,
      }
    );
  }

  static create(
    group: string,
    context?: Partial<ValidationContextBase>
  ): OnlyOneSingleAppointmentTypeValidator {
    return new OnlyOneSingleAppointmentTypeValidator(group, context);
  }
}

export const onlyOneSingleAppointmentTypeValidatorProvider: ValueProvider = {
  provide: VALIDATOR_FACTORY,
  useValue: {
    name: 'onlyOneSingleAppointmentType',
    fn: OnlyOneSingleAppointmentTypeValidator.create,
  },
  multi: true,
};
